import { Formik, Form } from "formik"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { useSelector, useDispatch } from "react-redux"

import TextInput from "../../../../components/Inputs/TextInput"
import Loader from "../../../../components/Loader/Loader"
import validateEducationDetails from "../../Profile/Forms/validation/validateEducationDetails"
import {
    deleteEducationRow,
    editEducationDetails,
    submitEducationDetails,
} from "../../../../features/auth/authSlice"
import { MdDeleteForever } from "react-icons/md"
import { closeModal } from "../../../../features/modal/modalSlice"

const EducationForm = ({ edu: selectedRow }) => {
    const dispatch = useDispatch()
    const { isLoading } = useSelector((state) => state.auth)

    const handleSubmit = (values, actions) => {
        if (selectedRow) {
            dispatch(editEducationDetails({ values, actions })).then(() =>
                dispatch(closeModal())
            )
        } else {
            dispatch(submitEducationDetails({ values, actions })).then(() =>
                dispatch(closeModal())
            )
        }
    }

    const handleDeleteBtn = (id) => {
        if (window.confirm("Are you sure you want to delete this details?")) {
            dispatch(deleteEducationRow(id))
        }
    }

    const initialValues = {
        college: "",
        course: "",
        from: "",
        to: "",
    }

    let editRowValues = {
        college: "",
        course: "",
        from: "",
        to: "",
        id: "",
    }

    if (selectedRow) {
        editRowValues = {
            college: selectedRow.college_name,
            course: selectedRow.course_name,
            from: new Date(`${selectedRow.start}-01-01`),
            to: new Date(`${selectedRow.end}-01-01`),
            id: selectedRow.id,
        }
    }

    return (
        <div>
            <Formik
                initialValues={selectedRow ? editRowValues : initialValues}
                validationSchema={validateEducationDetails}
                enableReinitialize={true}
                onSubmit={(values, actions) => {
                    handleSubmit(values, actions)
                }}
            >
                {(formikProps) => (
                    <Form>
                        <TextInput
                            name="college"
                            type="text"
                            placeholder="COLLEGE NAME"
                            color="dark"
                        />
                        <TextInput
                            name="course"
                            type="text"
                            placeholder="COURSE NAME"
                            color="dark"
                        />
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                            <div className="w-full">
                                <label>From: </label>
                                <DatePicker
                                    selected={formikProps.values.from}
                                    onChange={(date) =>
                                        formikProps.setFieldValue("from", date)
                                    }
                                    maxDate={new Date()}
                                    showYearPicker
                                    dateFormat="yyyy"
                                    className="text-input"
                                    placeholderText="Click to select year"
                                />
                                {formikProps.touched.from &&
                                formikProps.errors.from ? (
                                    <div className="input-error ">
                                        {formikProps.errors.from}
                                    </div>
                                ) : null}
                            </div>
                            <div className="w-full">
                                <label>To: </label>
                                <DatePicker
                                    selected={formikProps.values.to}
                                    onChange={(date) =>
                                        formikProps.setFieldValue("to", date)
                                    }
                                    maxDate={new Date()}
                                    showYearPicker
                                    dateFormat="yyyy"
                                    className="text-input"
                                    placeholderText="Click to select year"
                                />
                                {formikProps.touched.to &&
                                formikProps.errors.to ? (
                                    <div className="input-error ">
                                        {formikProps.errors.to}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="flex justify-end mt-8">
                            <div className="flex space-x-4">
                                {selectedRow && selectedRow.id && (
                                    <button
                                        className="text-2xl mr-2 text-red-500 self-center"
                                        type="button"
                                        title="Delete"
                                        onClick={() =>
                                            handleDeleteBtn(selectedRow.id)
                                        }
                                    >
                                        <MdDeleteForever />
                                    </button>
                                )}
                                <button
                                    type="submit"
                                    className="text-white px-6 py-2 submit-btn"
                                    disabled={isLoading ? true : false}
                                >
                                    {isLoading ? (
                                        <div className="inline-flex">
                                            <Loader
                                                size="6"
                                                classes="mr-2 w-6 h-6 fill-blue-200"
                                            />
                                            <div className="self-center">
                                                Please wait...
                                            </div>
                                        </div>
                                    ) : selectedRow ? (
                                        `Update Details`
                                    ) : (
                                        `Add Details`
                                    )}
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default EducationForm
